import { render } from "./CompanyCreationView.vue?vue&type=template&id=5a2d34b3"
import script from "./CompanyCreationView.vue?vue&type=script&lang=js"
export * from "./CompanyCreationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SetUp/Company/CompanyCreationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a2d34b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a2d34b3', __exports__)) {
    api.reload('5a2d34b3', __exports__)
  }
  
  module.hot.accept("./CompanyCreationView.vue?vue&type=template&id=5a2d34b3", () => {
    api.rerender('5a2d34b3', render)
  })

}


export default __exports__